/**
 * Die Navigationspunkte der Anwendung.
 *
 * Gleiche Form wie in der Tremor-Vorlage, damit die kopierten Bausteine
 * unverändert darauf zugreifen — nur Inhalt und Adressen sind unsere.
 */
export const siteConfig = {
  name: "cubic studio",
  url: "https://studio.cubic-meta.de",
  description:
    "Team-Werkzeug für Projekte, Aufgaben, Wissensseiten und Content.",
  baseLinks: {
    projekte: "/projekte",
    aufgaben: "/aufgaben",
    klaerungen: "/klaerungen",
    seiten: "/seiten",
    benachrichtigungen: "/benachrichtigungen",
    einstellungen: {
      persoenlich: "/einstellungen/persoenlich",
      zeitplanung: "/einstellungen/zeitplanung",
      sichten: "/einstellungen/sichten",
      team: "/einstellungen/team",
      instanz: "/einstellungen/instanz",
      metarr: "/metarr",
      gitlab: "/einstellungen/gitlab",
      /** @deprecated alte Adresse, leitet um */
      allgemein: "/einstellungen/persoenlich",
      personen: "/einstellungen/team",
      kalender: "/einstellungen/zeitplanung",
      kapazitaet: "/einstellungen/zeitplanung",
    },
    anmeldung: "/anmeldung",
    einrichtung: "/einrichtung",
  },
};

export type siteConfig = typeof siteConfig;
